module.exports = __webpack_public_path__ + "static/organise@2x-a352037b94eb0e0831fbf463af82e2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/organise@2x.png
// module id = 1092
// module chunks = 168707334958949